import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import {
  TiptapEditor,
  TiptapEditorUpdatePayload,
} from 'client/components/core/tiptap-editor'
import { useAppDispatch } from 'client/hooks/use-dispatch'
import { useManagement } from 'client/store'
import managementSelectors from 'client/store/management/managementSelectors'
import { updateEntity } from 'client/store/page/pageActions'
import { EntityProps } from 'client/types'
import CommonBulletList from 'common/components/entities/BulletList'
import { bulletListIconsOld } from 'common/constants/iconList'
import { BulletListInterface } from 'common/types/entities/BulletListInterface'
import React, { memo } from 'react'
import { useCalculateTypography } from 'src/editor/shared/hooks/use-calculate-typography'
import { useThemeColor } from 'src/editor/shared/hooks/use-theme-color'

function BlogBulletList({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<BulletListInterface>) {
  const dispatch = useAppDispatch()
  const isEditing = useManagement(m =>
    managementSelectors.isEditing(m, entity.id),
  )

  const {
    text: { paragraphTextColor, paragraphBackgroundColor },
    links: { linkTextColor },
  } = useThemeColor()

  const {
    calculatedFontSize,
    calculatedLineHeight,
    calculatedTextAlign,
    calculatedFontFamily,
    calculatedFontWeight,
    calculatedFontStyle,
  } = useCalculateTypography({
    fontSize: entity.fontSize,
    mobileFontSize: entity.mobileFontSize,
    lineHeight: entity.lineHeight,
    mobileLineHeight: entity.mobileLineHeight,
    textAlign: entity.textAlign,
    mobileTextAlign: entity.mobileTextAlign,
    fontFamily: entity.fontFamily,
    mobileFontFamily: entity.mobileFontFamily,
    fontWeight: entity.fontWeight,
    mobileFontWeight: entity.mobileFontWeight,
    fontStyle: entity.fontStyle,
    mobileFontStyle: entity.mobileFontStyle,
  })

  const updateText = (payload: TiptapEditorUpdatePayload) => {
    dispatch(
      updateEntity({
        ...entity,
        ...payload,
      }),
    )
  }

  //check if it's old className
  const iconClassName =
    entity.listItemClassName.indexOf('fa') < 0
      ? bulletListIconsOld[
          entity.listItemClassName as keyof typeof bulletListIconsOld
        ]
      : entity.listItemClassName

  return (
    <BaseEntityNew
      entity={entity}
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
    >
      <CommonBulletList
        isEditing={isEditing}
        verticalSpacing={entity.verticalSpacing}
        mobileVerticalSpacing={entity.mobileVerticalSpacing}
        listItemIconColor={entity.listItemIconColor}
        mobileListItemIconColor={entity.mobileListItemIconColor}
        listItemIconSize={entity.listItemIconSize}
      >
        <TiptapEditor
          content={entity.content || entity.rawContentState || ''}
          textAlign={calculatedTextAlign.desktop}
          attrId={entity.htmlAttrId}
          isEditing={isEditing}
          update={updateText}
          padding={entity.padding}
          textColor={paragraphTextColor}
          linkColor={linkTextColor}
          fontSize={calculatedFontSize.desktop}
          fontStyle={calculatedFontStyle.desktop}
          fontFamily={calculatedFontFamily.desktop}
          mobileFontFamily={calculatedFontFamily.mobile}
          fontWeight={calculatedFontWeight.desktop}
          lineHeight={calculatedLineHeight.desktop}
          mobilePadding={entity.mobilePadding}
          mobileFontSize={calculatedFontSize.mobile}
          mobileLineHeight={calculatedLineHeight.mobile}
          mobileFontStyle={calculatedFontStyle.mobile}
          mobileFontWeight={calculatedFontWeight.mobile}
          backgroundColor={entity.backgroundColor || paragraphBackgroundColor}
          mobileBackgroundColor={
            entity.mobileBackgroundColor || paragraphBackgroundColor
          }
          iconClassName={iconClassName}
          isBulletList
          isBlogPage
        />
      </CommonBulletList>
    </BaseEntityNew>
  )
}

export default memo(BlogBulletList)
